import AbstractShape, {Dimensions, DimensionProperties} from "./AbstractShape";
import Length from "../../../../source/js/shared/models/Geometry/Length";
import DimensionLine from "@/Models/Lines/DimensionLine";

export class Parallelogram extends AbstractShape {
	angle = 60; // Defined in makerjs.js

	constructor( dimensions?: object ) {
		super( 'parallelogram', dimensions );
	}

	getHeight(): Length {
		return this.cleanedPrimitives.height;
	}

	getLength(): Length {
		return this.cleanedPrimitives.height;
	}

	getWidth(): Length {
		return this.cleanedPrimitives.width;
	}

	getSlantedWidth(): Length {
		const angleRadians = this.angle * Math.PI / 180;
		const slantHeight = this.getHeight().in_mm() / Math.sin(angleRadians);
		const width = slantHeight * Math.cos(angleRadians);

		return Length.from_mm(width);
	}

	getDimensionProperties(): DimensionProperties {
		return { primary: 'height', secondary: 'width' };
	}

	getDimensionLines(ratio = 1, focusedElement = '', forceRender = false): DimensionLine[] {
		if(focusedElement.includes("cutout_measurement") || forceRender) {
			return [
				new DimensionLine( [0, 0], [ 0, this.getHeight().in_mm() ], this.renderDimensionLabel( 'height' ), [-40, 0], ratio, this.getDimensionLineType('measurements-parallelogram-height', focusedElement, forceRender) ), // Vertical line
				new DimensionLine( [0, 0], [ this.getWidth().in_mm(), 0 ], this.renderDimensionLabel( 'width' ), [0, -40], ratio, this.getDimensionLineType('measurements-parallelogram-width', focusedElement, forceRender) ), // Horizontal line
				new DimensionLine([0, this.getHeight().in_mm()], [this.getSlantedWidth().add(this.getWidth()).in_mm(), this.getHeight().in_mm()], this.renderDimensionLabel('width', this.getSlantedWidth().add(this.getWidth()).in_cm()), [0, 40], ratio),
			];
		}

		return [];
	}

	getDefaultDimensions(): Dimensions {
		return {
			height: 60,
			width: 100,
		};
	}

	getDefaultCutoutDimensions(parentShape: AbstractShape): Dimensions {
		const enclosingRectangle = parentShape.getEnclosingRectangle();
		const width = enclosingRectangle.width();
		const height = enclosingRectangle.height();

		return {
			width: width.divide(2).in_cm(),
			height: height.divide(3).in_cm(),
		};
	}
}
